// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Control_Monad_Reader_Class from "../Control.Monad.Reader.Class/index.js";
import * as Control_Monad_Replace from "../Control.Monad.Replace/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Specular_Dom_Browser from "../Specular.Dom.Browser/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_WeakDynamic from "../Specular.FRP.WeakDynamic/index.js";
import * as Specular_Internal_Effect from "../Specular.Internal.Effect/index.js";
import * as Specular_Internal_RIO from "../Specular.Internal.RIO/index.js";
import * as Specular_Profiling from "../Specular.Profiling/index.js";
var $runtime_lazy = function (name, moduleName, init) {
    var state = 0;
    var val;
    return function (lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var Builder = function (x) {
    return x;
};
var unBuilder = function (v) {
    return v;
};
var setParent = function (parent) {
    return function (env) {
        return {
            parent: parent,
            cleanup: env.cleanup,
            userEnv: env.userEnv
        };
    };
};
var runBuilderWithUserEnv = function (userEnv) {
    return function (parent) {
        return function (v) {
            return function __do() {
                var actionsMutable = Specular_Internal_Effect.emptyDelayed();
                var env = {
                    parent: parent,
                    cleanup: actionsMutable,
                    userEnv: userEnv
                };
                var result = Specular_Internal_RIO.runRIO(env)(v)();
                var actions = Specular_Internal_Effect.unsafeFreezeDelayed(actionsMutable)();
                return new Data_Tuple.Tuple(result, Specular_Internal_Effect.sequenceEffects(actions));
            };
        };
    };
};
var runBuilder$prime = function (env, v) {
    return v(env);
};
var runBuilder = /* #__PURE__ */ runBuilderWithUserEnv(Data_Unit.unit);
var monadEffectBuilder = Specular_Internal_RIO.monadEffectRIO;
var monadBuilder = Specular_Internal_RIO.monadRIO;
var mkBuilder$prime = function ($32) {
    return Builder(Specular_Internal_RIO.RIO($32));
};
var mkBuilder = function ($33) {
    return Builder(Specular_Internal_RIO.rio($33));
};
var monadCleanupBuilder = {
    onCleanup: function (action) {
        return mkBuilder(function (env) {
            return Specular_Internal_Effect.pushDelayed(env.cleanup)(action);
        });
    },
    Monad0: function () {
        return monadBuilder;
    }
};
var local = function (fn) {
    return function (v) {
        return Specular_Internal_RIO.local(function (env) {
            return {
                userEnv: fn(env.userEnv),
                cleanup: env.cleanup,
                parent: env.parent
            };
        })(v);
    };
};
var getParentNode = /* #__PURE__ */ Control_Monad_Reader_Class.asks(Specular_Internal_RIO.monadAskRIO)(function (v) {
    return v.parent;
});
var getEnv = /* #__PURE__ */ Control_Monad_Reader_Class.ask(Specular_Internal_RIO.monadAskRIO);
var functorBuilder = Specular_Internal_RIO.functorRIO;
var monadAskBuilder = {
    ask: /* #__PURE__ */ Data_Functor.map(functorBuilder)(function (v) {
        return v.userEnv;
    })(getEnv),
    Monad0: function () {
        return monadBuilder;
    }
};
var monadReaderBuilder = {
    local: local,
    MonadAsk0: function () {
        return monadAskBuilder;
    }
};
var bindBuilder = Specular_Internal_RIO.bindRIO;
var applyBuilder = Specular_Internal_RIO.applyRIO;
var semigroupBuilder = function (dictSemigroup) {
    return {
        append: Control_Apply.lift2(applyBuilder)(Data_Semigroup.append(dictSemigroup))
    };
};
var applicativeBuilder = Specular_Internal_RIO.applicativeRIO;
var monadDomBuilderBuilder = {
    text: function (str) {
        return mkBuilder(function (env) {
            return function __do() {
                var node = Specular_Dom_Browser.createTextNode(str)();
                return Specular_Dom_Browser.appendChild(node)(env.parent)();
            };
        });
    },
    dynText: function (dstr) {
        return Control_Bind.bind(bindBuilder)(mkBuilder(function (env) {
            return function __do() {
                var node = Specular_Dom_Browser.createTextNode("")();
                Specular_Dom_Browser.appendChild(node)(env.parent)();
                return node;
            };
        }))(function (node) {
            return Specular_FRP_WeakDynamic.subscribeWeakDyn_(Specular_FRP_Base.monadFRP(monadEffectBuilder)(monadCleanupBuilder))(Specular_Dom_Browser.setText(node))(dstr);
        });
    },
    rawHtml: function (html) {
        return mkBuilder(function (env) {
            return Specular_Dom_Browser.appendRawHtml(html)(env.parent);
        });
    },
    "elDynAttrNS'": function (namespace) {
        return function (tagName) {
            return function (dynAttrs) {
                return function (inner) {
                    return Control_Bind.bind(bindBuilder)(getEnv)(function (env) {
                        return Control_Bind.bind(bindBuilder)(Effect_Class.liftEffect(monadEffectBuilder)(Specular_Dom_Browser.createElementNS(namespace)(tagName)))(function (node) {
                            return Control_Bind.bind(bindBuilder)(Effect_Class.liftEffect(monadEffectBuilder)(Effect_Ref["new"](Data_Monoid.mempty(Foreign_Object.monoidObject(Data_Semigroup.semigroupString)))))(function (attrsRef) {
                                var resetAttributes = function (newAttrs) {
                                    return function __do() {
                                        var oldAttrs = Effect_Ref.read(attrsRef)();
                                        Effect_Ref.write(newAttrs)(attrsRef)();
                                        var removed = Data_Array.filter(function (k) {
                                            return !Foreign_Object.member(k)(newAttrs);
                                        })(Foreign_Object.keys(oldAttrs));
                                        var changed = Foreign_Object.filterWithKey(function (k) {
                                            return function (v) {
                                                return Data_Eq.notEq(Data_Maybe.eqMaybe(Data_Eq.eqString))(Foreign_Object.lookup(k)(oldAttrs))(new Data_Maybe.Just(v));
                                            };
                                        })(newAttrs);
                                        Specular_Dom_Browser.removeAttributes(node)(removed)();
                                        return Specular_Dom_Browser.setAttributes(node)(changed)();
                                    };
                                };
                                return Control_Bind.discard(Control_Bind.discardUnit)(bindBuilder)(Specular_FRP_WeakDynamic.subscribeWeakDyn_(Specular_FRP_Base.monadFRP(monadEffectBuilder)(monadCleanupBuilder))(resetAttributes)(dynAttrs))(function () {
                                    return Control_Bind.bind(bindBuilder)(Specular_Internal_RIO.local(setParent(node))(unBuilder(inner)))(function (result) {
                                        return Control_Bind.discard(Control_Bind.discardUnit)(bindBuilder)(Effect_Class.liftEffect(monadEffectBuilder)(Specular_Dom_Browser.appendChild(node)(env.parent)))(function () {
                                            return Control_Applicative.pure(applicativeBuilder)(new Data_Tuple.Tuple(node, result));
                                        });
                                    });
                                });
                            });
                        });
                    });
                };
            };
        };
    },
    elAttr: function (tagName) {
        return function (attrs) {
            return function (inner) {
                return Control_Bind.bind(bindBuilder)(getEnv)(function (env) {
                    return Control_Bind.bind(bindBuilder)(Effect_Class.liftEffect(monadEffectBuilder)(Specular_Dom_Browser.createElementNS(Data_Maybe.Nothing.value)(tagName)))(function (node) {
                        return Control_Bind.discard(Control_Bind.discardUnit)(bindBuilder)(Effect_Class.liftEffect(monadEffectBuilder)(Specular_Dom_Browser.setAttributes(node)(attrs)))(function () {
                            return Control_Bind.bind(bindBuilder)(Specular_Internal_RIO.local(setParent(node))(unBuilder(inner)))(function (result) {
                                return Control_Bind.discard(Control_Bind.discardUnit)(bindBuilder)(Effect_Class.liftEffect(monadEffectBuilder)(Specular_Dom_Browser.appendChild(node)(env.parent)))(function () {
                                    return Control_Applicative.pure(applicativeBuilder)(result);
                                });
                            });
                        });
                    });
                });
            };
        };
    },
    liftBuilder: function (fn) {
        return fn;
    },
    liftBuilderWithRun: function (fn) {
        return Specular_Internal_RIO.rio(function (env) {
            return function () {
                return fn(env, function (env$prime, v) {
                    return v(env$prime);
                });
            };
        });
    },
    Monad0: function () {
        return monadBuilder;
    }
};
var $lazy_monadReplaceBuilder = /* #__PURE__ */ $runtime_lazy("monadReplaceBuilder", "Specular.Dom.Builder", function () {
    return {
        newSlot: Control_Bind.bind(bindBuilder)(getEnv)(function (env) {
            return Control_Bind.bind(bindBuilder)(Effect_Class.liftEffect(monadEffectBuilder)(Specular_Dom_Browser.createTextNode("")))(function (placeholderBefore) {
                return Control_Bind.bind(bindBuilder)(Effect_Class.liftEffect(monadEffectBuilder)(Specular_Dom_Browser.createTextNode("")))(function (placeholderAfter) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(bindBuilder)(Effect_Class.liftEffect(monadEffectBuilder)(Specular_Dom_Browser.appendChild(placeholderBefore)(env.parent)))(function () {
                        return Control_Bind.discard(Control_Bind.discardUnit)(bindBuilder)(Effect_Class.liftEffect(monadEffectBuilder)(Specular_Dom_Browser.appendChild(placeholderAfter)(env.parent)))(function () {
                            return Control_Bind.bind(bindBuilder)(Effect_Class.liftEffect(monadEffectBuilder)(Effect_Ref["new"](Data_Monoid.mempty(Effect.monoidEffect(Data_Monoid.monoidUnit)))))(function (cleanupRef) {
                                var replace = function (inner) {
                                    return Specular_Profiling.measure(Effect_Class.monadEffectEffect)("slot replace")(function __do() {
                                        Specular_Profiling.measure(Effect_Class.monadEffectEffect)("slot remove DOM")(Specular_Dom_Browser.removeAllBetween(placeholderBefore)(placeholderAfter))();
                                        var fragment = Specular_Dom_Browser.createDocumentFragment();
                                        var v = Specular_Profiling.measure(Effect_Class.monadEffectEffect)("slot init")(runBuilderWithUserEnv(env.userEnv)(fragment)(inner))();
                                        Control_Bind.join(Effect.bindEffect)(Effect_Ref.read(cleanupRef))();
                                        var m_parent = Specular_Dom_Browser.parentNode(placeholderAfter)();
                                        (function () {
                                            if (m_parent instanceof Data_Maybe.Just) {
                                                Specular_Dom_Browser.insertBefore(fragment)(placeholderAfter)(m_parent.value0)();
                                                return Effect_Ref.write(Specular_Profiling.measure(Effect_Class.monadEffectEffect)("slot cleanup")(function __do() {
                                                    v.value1();
                                                    return Effect_Ref.write(Data_Monoid.mempty(Effect.monoidEffect(Data_Monoid.monoidUnit)))(cleanupRef)();
                                                }))(cleanupRef)();
                                            };
                                            if (m_parent instanceof Data_Maybe.Nothing) {
                                                return Effect_Ref.write(v.value1)(cleanupRef)();
                                            };
                                            throw new Error("Failed pattern match at Specular.Dom.Builder (line 118, column 9 - line 131, column 37): " + [ m_parent.constructor.name ]);
                                        })();
                                        return v.value0;
                                    });
                                };
                                var destroy = function __do() {
                                    Specular_Dom_Browser.removeAllBetween(placeholderBefore)(placeholderAfter)();
                                    Specular_Dom_Browser.removeNode(placeholderBefore)();
                                    Specular_Dom_Browser.removeNode(placeholderAfter)();
                                    return Control_Bind.join(Effect.bindEffect)(Effect_Ref.read(cleanupRef))();
                                };
                                var append = function __do() {
                                    var fragment = Specular_Dom_Browser.createDocumentFragment();
                                    var v = runBuilderWithUserEnv(env.userEnv)(fragment)(Control_Monad_Replace.newSlot($lazy_monadReplaceBuilder(0)))();
                                    Effect_Ref.modify_(function (v1) {
                                        return Control_Apply.applySecond(Effect.applyEffect)(v1)(v.value1);
                                    })(cleanupRef)();
                                    var m_parent = Specular_Dom_Browser.parentNode(placeholderAfter)();
                                    (function () {
                                        if (m_parent instanceof Data_Maybe.Just) {
                                            return Specular_Dom_Browser.insertBefore(fragment)(placeholderAfter)(m_parent.value0)();
                                        };
                                        if (m_parent instanceof Data_Maybe.Nothing) {
                                            return Data_Unit.unit;
                                        };
                                        throw new Error("Failed pattern match at Specular.Dom.Builder (line 150, column 9 - line 154, column 22): " + [ m_parent.constructor.name ]);
                                    })();
                                    return v.value0;
                                };
                                return Control_Bind.discard(Control_Bind.discardUnit)(bindBuilder)(Control_Monad_Cleanup.onCleanup(monadCleanupBuilder)(Control_Bind.join(Effect.bindEffect)(Effect_Ref.read(cleanupRef))))(function () {
                                    return Control_Applicative.pure(applicativeBuilder)(new Control_Monad_Replace.Slot(replace, destroy, append));
                                });
                            });
                        });
                    });
                });
            });
        }),
        Monad0: function () {
            return monadBuilder;
        },
        MonadCleanup1: function () {
            return monadCleanupBuilder;
        }
    };
});
var monadReplaceBuilder = /* #__PURE__ */ $lazy_monadReplaceBuilder(93);
var monoidBuilder = function (dictMonoid) {
    return {
        mempty: Control_Applicative.pure(applicativeBuilder)(Data_Monoid.mempty(dictMonoid)),
        Semigroup0: function () {
            return semigroupBuilder(dictMonoid.Semigroup0());
        }
    };
};
export {
    runBuilder,
    local,
    unBuilder,
    mkBuilder$prime,
    runBuilder$prime,
    getParentNode,
    functorBuilder,
    applyBuilder,
    applicativeBuilder,
    bindBuilder,
    monadBuilder,
    monadEffectBuilder,
    monadCleanupBuilder,
    monadAskBuilder,
    monadReaderBuilder,
    monadReplaceBuilder,
    monadDomBuilderBuilder,
    semigroupBuilder,
    monoidBuilder
};
//# sourceMappingURL=index.js.map
